import "./productCard.scss";
import { useNavigate } from "react-router-dom";
import emptyImage from "assets/images/imgs/emptyImg.png";

//클래스탭 > 판매하는 수강권 카드
const ProductCard = ({ info, link }) => {
    const navigate = useNavigate();

    // 이미지 URL 결정 로직 개선
    const getImageUrl = () => {
        if (Array.isArray(info.images) && info?.images.length > 0) {
            return info.images[0].image;
        }
        return emptyImage;
    };

    // 클릭 핸들러
    const handleClick = () => {
        navigate(link);
    };

    // 키보드 핸들러
    const handleKeyDown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleClick();
        }
    };
    return (
        <div
            className="product-card-container"
            role="button"
            tabIndex={0}
            aria-label={`${info.title} 클래스 상세보기`}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
        >
            <img
                src={getImageUrl()}
                alt={info.description || info.title || "클래스 이미지"}
                onError={(e) => {
                    e.currentTarget.src = emptyImage;
                }}
            />
            <div className="class-content">
                <p className="title">
                    {`[${info.brand}] ${info.name}`}
                </p>
                <div className="price-wrap">
                    <p className="price-row">
                        {info.discount_rate && (
                            <span className="discount">
                                {Math.floor(info.discount_rate)}%
                            </span>
                        )}
                        <span className="price">
                            {Number(info.discount_price || 0).toLocaleString()}원
                        </span>
                        {info.has_options && <span className="option-badge">옵션</span>}
                    </p>
                    {info.discount_rate && (
                        <p className="original-price">
                            {Number(info.price || 0).toLocaleString()}원
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};
export default ProductCard;
